export default "__VITE_ASSET__73cbb280__"